import Axios from 'axios';

const internals = {
    host: import.meta.env.VITE_API_HOST,
    getApiBase: () => {
        const { host } = internals;

        return host;
    },
};

const client = Axios.create({
    baseURL: internals.getApiBase(),
    responseType: 'json',
    headers: { common: {} },
});
export default client;

client.batch = (reqs) => {
    const { prefix } = internals;

    const requests = reqs.map((request) => ({
        ...request,
        path: `${prefix}${request.path}`,
    }));

    return client.post(internals.getApiBase(), { requests });
};

client.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// see routes/index for response interceptor for handling auth failure redirects
